import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const activityApi = createApi({
    reducerPath: "activityApi",
    baseQuery: baseQueryWithReauth,
    tagTypes: ["Activity"],
    endpoints: (builder) => ({
        getRecentActivities: builder.query({
            query: (params) => ({
                url: "/activities",
                params,
            }),
            providesTags: ["Activity"],
        }),
        getActivityStats: builder.query({
            query: () => "/activities/stats",
            providesTags: ["Activity"],
        }),
    }),
});

export const { useGetRecentActivitiesQuery, useGetActivityStatsQuery } = activityApi;
